import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type UserDetailsSectionProps = {
  icon: ReactNode;
  title?: string;
  children: ReactNode;
};

export function UserDetailsSection({ icon, title, children }: UserDetailsSectionProps) {
  return (
    <Box>
      {title && (
        <Typography variant="overline" component="h3" color="text.secondary" px={1.5}>
          {title}
        </Typography>
      )}
      <Card variant="outlined">
        <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box color="text.secondary" display="flex" alignItems="center">
              {icon}
            </Box>
            <Box minWidth={0} flex={1}>
              {children}
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
